import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetCategory } from "../../redux/slices/GetCategorySlice";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineArrowLeft } from "react-icons/ai";
import WebsiteFooter from "../../Fotter";
import { GetCategoryData } from "../../redux/slices/GetCategoryDataSlice";
import Loader from "../../Loader";

function ViewAllCategory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { AllCategory } = useSelector((state) => state.category);
  const [loader, setLoader] = useState(false);
  const [hiddenCategoryIds, setHiddenCategoryIds] = useState([]);

  useEffect(() => {
    dispatch(GetCategory());
  }, [dispatch]);

  useEffect(() => {
    const checkAllCategories = async () => {
      if (!AllCategory || AllCategory.length === 0) return;
      try {
        // setLoader(true);
        const checks = await Promise.all(
          AllCategory.map(async (category) => {
            try {
              const result = await dispatch(GetCategoryData(category.name)).unwrap();
              if (!result?.data || result?.data.length === 0) {
                return category._id;
              }
            } catch (error) {
              console.error(`Error checking category ${category.name}:`, error);
            }
            return null;
          })
        );

        const emptyIds = checks.filter((id) => id !== null);
        setHiddenCategoryIds(emptyIds);
      } catch (error) {
        console.error("Error checking categories:", error);
      } finally {
        setLoader(false);
      }
    };

    checkAllCategories();
  }, [AllCategory, dispatch]);

  const _handleClick = (item) => {
    const url =
      item?.name && item?._id
        ? item?.category
          ? `/ShowCategoryData/${item.name}/${item._id}/${item.category}`
          : `/ShowCategoryData/${item.name}/${item._id}`
        : "";

    if (!url) return;
    navigate(url);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow">
        <div className="sm:mt-10 mt-10 flex mx-auto items-center w-[90%] justify-between">
          <button
            onClick={() => navigate(-1)}
            className="mr-2 bg-gray-200 px-2 py-2 rounded-full flex items-center"
          >
            <AiOutlineArrowLeft className="text-lg mr-1" />
          </button>
          <h1 className="text-lg m font-bold text-center">
            View All Categories
          </h1>
          <h1></h1>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 xl:grid-cols-8 gap-5 mt-2 w-[95%] p-2 mx-auto">
          {AllCategory
            ?.filter((category) => !hiddenCategoryIds.includes(category._id))
            .map((category, index) => (
              <div
                key={category._id || index}
                onClick={() => _handleClick(category)}
                className="flex flex-col items-center p-1 cursor-pointer rounded-lg bg-white hover:shadow-lg transition-shadow"
              >
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-16 h-16 rounded-full object-cover border border-gray-200"
                />
                <p className="text-center font-medium text-gray-700 line-clamp-1">
                  {category.name}
                </p>
              </div>
            ))}
        </div>

        {loader && <Loader />}
      </div>
      <WebsiteFooter />
    </div>
  );
}

export default ViewAllCategory;